import BusinessImage from '@/assets/img/profile/styles/Business.png'
import CasualImage from '@/assets/img/profile/styles/Casual.png'
import BoldImage from '@/assets/img/profile/styles/Bold.png'
import SportChicImage from '@/assets/img/profile/styles/Sport chic.png'
import SexualImage from '@/assets/img/profile/styles/Sexual.png'
import CreativeImage from '@/assets/img/profile/styles/Creative.png'
import SmartCasualImage from '@/assets/img/profile/styles/Smart casual.png'
import RomanticImage from '@/assets/img/profile/styles/Romantic.png'
import HomeClothesImage from '@/assets/img/profile/styles/Home clothes.png'
import BeachwearImage from '@/assets/img/profile/styles/Beachwear.png'
import StylesIconsImage from '@/assets/img/profile/styles/Styles_icons.png'

const styleImageMap: Record<string, string> = {
  'Деловой': BusinessImage,
  'Business': BusinessImage,
  'Кэжуал': CasualImage,
  'Casual': CasualImage,
  'Дерзкий': BoldImage,
  'Bold': BoldImage,
  'Спорт-шик': SportChicImage,
  'Sport chic': SportChicImage,
  'Сексуальный': SexualImage,
  'Sexual': SexualImage,
  'Творческий': CreativeImage,
  'Creative': CreativeImage,
  'Смарт-кэжуал': SmartCasualImage,
  'Smart casual': SmartCasualImage,
  'Романтический': RomanticImage,
  'Romantic': RomanticImage,
  'Домашняя одежда': HomeClothesImage,
  'Home clothes': HomeClothesImage,
  'Пляжная одежда': BeachwearImage,
  'Beachwear': BeachwearImage,
  'Спортивная одежда': StylesIconsImage,
  'Sport': StylesIconsImage,
  'Sports': StylesIconsImage
}

/**
 * Маппинг styleId из API на файлы в public/img/taste
 * Ключи - это styleId из API (snake_case или kebab-case)
 * Значения - имена файлов в public/img/taste
 */
const styleIdToTasteImageMap: Record<string, string> = {
  'business': '/img/taste/Business.png',
  'office': '/img/taste/Business.png', // Деловой стиль
  'casual': '/img/taste/casual.png',
  'bold': '/img/taste/Bold.png',
  'drama_bold': '/img/taste/Bold.png',
  'edgy': '/img/taste/Bold.png',
  'sport': '/img/taste/Sport chic.png',
  'sport_chic': '/img/taste/Sport chic.png',
  'sport-chic': '/img/taste/Sport chic.png',
  'sportswear': '/img/taste/Sportswear.png',
  'sexual': '/img/taste/Sexual.png',
  'lingerie': '/img/taste/Sexual.png',
  'creative': '/img/taste/creative.png',
  'artistic': '/img/taste/creative.png',
  'smart_casual': '/img/taste/Smart casual.png',
  'smart-casual': '/img/taste/Smart casual.png',
  'romantic': '/img/taste/Romantic.png',
  'home_clothes': '/img/taste/home closes.png',
  'home-clothes': '/img/taste/home closes.png',
  'domestic': '/img/taste/home closes.png',
  'beachwear': '/img/taste/beachwear.png',
  'beach': '/img/taste/beachwear.png',
  'evening': '/img/taste/Sexual.png', // Вечерний стиль - используем сексуальный как ближайший
  'western': '/img/taste/casual.png', // Вестерн - используем кэжуал
  'vintage': '/img/taste/Romantic.png', // Винтаж - используем романтический
  'punk': '/img/taste/Bold.png', // Панк - используем дерзкий
  'kids': '/img/taste/question.png', // Детский стиль
  'classic': '/img/taste/Business.png', // Классический стиль
  'undefined': '/img/taste/question.png',
}

/**
 * Маппинг ID стилей из API /user/style на изображения
 * Ключи - это ID стилей из API
 * Значения - пути к изображениям в public/img/taste
 */
const styleIdToImageMap: Record<number, string> = {
  12: '/img/taste/Business.png', // Деловой
  17: '/img/taste/casual.png', // Кэжуал
  15: '/img/taste/Sport chic.png', // Спорт-шик
  21: '/img/taste/beachwear.png', // Пляжный
  23: '/img/taste/Sexual.png', // Вечерний
}

/**
 * Получает путь к изображению стиля из public/img/taste по styleId из API
 * @param styleId - styleId из API (number или string code, например, 'beach', 'smart_casual', 'drama_bold')
 * @returns путь к изображению в public/img/taste
 */
export function getStyleImageFromTaste(styleId: number | string): string {
  // Если это number, проверяем маппинг по ID
  if (typeof styleId === 'number') {
    if (styleIdToImageMap[styleId]) {
      return styleIdToImageMap[styleId]
    }
    return '/img/taste/question.png'
  }

  // Нормализуем styleId: приводим к нижнему регистру и заменяем дефисы на подчеркивания
  const normalizedId = styleId.toLowerCase().replace(/-/g, '_')
  return styleIdToTasteImageMap[normalizedId] || '/img/taste/question.png'
}

/**
 * Маппинг изображения стиля из бэкенда на локальный файл в public/img/taste
 * @param style - объект стиля с полями code и image
 * @returns путь к локальному изображению или исходный путь, если маппинг не найден
 */
export function mapStyleImageFromBackend(style: { code?: string; image?: string }): string {
  // Если есть code, используем его для маппинга
  if (style.code) {
    const normalizedCode = style.code.toLowerCase().replace(/-/g, '_')
    const mappedPath = styleIdToTasteImageMap[normalizedCode]
    if (mappedPath) {
      return mappedPath
    }
  }

  // Если code отсутствует или маппинг не найден, возвращаем исходный путь или дефолтное изображение
  return style.image || '/img/taste/question.png'
}

/**
 * Получает путь к изображению стиля (старая функция для обратной совместимости)
 * @param type - тип стиля (название или styleId)
 * @returns путь к изображению
 */
export function getStyleImage(type: string): string {
  // Сначала пробуем найти в старом маппере
  if (styleImageMap[type]) {
    return styleImageMap[type]
  }

  // Если не найдено, пробуем найти в маппере для taste
  return getStyleImageFromTaste(type)
}

/**
 * Получает изображение стиля для страницы "Мой стиль"
 * Использует маппинг по ID, названию или code
 * @param style - объект стиля из API /user/style
 * @returns путь к изображению
 */
export function getStyleImageForMyStyle(style: { id: number; name: string; code?: string }): string {
  // Сначала пробуем по ID
  if (styleIdToImageMap[style.id]) {
    return styleIdToImageMap[style.id]
  }

  // Затем пробуем по названию (русское или английское)
  if (styleImageMap[style.name]) {
    return styleImageMap[style.name]
  }

  // Затем пробуем по code, если есть
  if (style.code) {
    const normalizedCode = style.code.toLowerCase().replace(/-/g, '_')
    if (styleIdToTasteImageMap[normalizedCode]) {
      return styleIdToTasteImageMap[normalizedCode]
    }
  }

  // Fallback на дефолтное изображение
  return '/img/taste/question.png'
}